import { render, staticRenderFns } from "./CreateWhiteboardModal.vue?vue&type=template&id=c3f8c8b6&scoped=true"
import script from "./CreateWhiteboardModal.vue?vue&type=script&lang=ts"
export * from "./CreateWhiteboardModal.vue?vue&type=script&lang=ts"
import style0 from "./CreateWhiteboardModal.vue?vue&type=style&index=0&id=c3f8c8b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f8c8b6",
  null
  
)

export default component.exports